<template>
  <div v-if="showComponent"
       v-click-out="onClose"
       class="subscribe-dropdown">
    <BasePreloader v-if="pending"/>
    <button @click.prevent="onClose"
            class="subscribe-dropdown__close  reset-button">
      <BaseSvg name="ico-close"/>
    </button>
    <div class="subscribe-dropdown__title">{{ $tVacancies('Subscribe to this collection:') }}</div>
    <div class="subscribe-dropdown__list  subscribe-list">
      <div class="subscribe-list__content">
        <div v-for="(item, key) in messengers"
             :key="key"
             @click="toggleChannel(key)"
             :class="getSelector(item, key)"
             class="subscribe-list__item">
          <div class="subscribe-list__item-content">
            <BaseSvg :name="`ico-${key}`" width="3.1rem" height="3.2rem"/>
          </div>
          <div class="subscribe-list__name">{{item.name}}</div>
          <span class="subscribe-list__tick">
            <BaseSvg name="ico-check"/>
          </span>
        </div>
      </div>
    </div>
    <button @click.prevent="onClose"
            class="subscribe-dropdown__btn  base-btn  base-btn--outline-grey">Ok</button>
  </div>
</template>

<script>
  import {EMPLOYEE, PARTNER} from '../constants/usersTypes'

  export default {
    props: {
      pending: Boolean,
      messengers: {
        type: Object,
        required: true
      },
      toggleChannel: Function
    },
    data() {
      return {}
    },
    computed: {
      showComponent() {
        const userType = this.$store.state.user.profile && this.$store.state.user.profile.user_type
        return userType && userType === EMPLOYEE || userType === PARTNER
      }
    },
    methods: {
      getSelector(item, key) {
        return {
          ['_' + key]: true,
          _disabled: item.disabled,
          _active: item.selected
        }
      },
      onClose() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="less">

</style>
